/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'

import { getUserProfile } from '../../../../assets/ts/data/user-profile'
import { convertDate } from '../../../../assets/ts/date-and-time/date-and-time'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import useTooltipMetadata from '../../../../hooks/use-tooltip-metadata'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import AddEditView from './add-edit-view'

interface toolTipItems {
  ItemKey: string
  created: null | string
  description: string
  labelid: string
  modifiedBy: string
  modifiedDate: string 
  name: string
}
const FormTooltip = (props: any) => {
  const {fetchTooltipMetdata, tooltipMetadata, tooltipMetadataIsLoading } = useTooltipMetadata({
    isArchived: null,
  })
  const [showAddPopup, setshowAddPopup] = useState(false)
  const [tooltipItems, setTooltipItems] = useState<toolTipItems[]>([])
  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false,
  })
  function addEditValue(showAddPopup: any) {
    setshowAddPopup(showAddPopup)
  }
  const [showEdit, setEdit] = useState(false)
  /* Function call on edit */
  const onEdit = (item: any) => {
    setInEditMode({
      rowKey: item.ItemKey,
      status: true,
    })
    setEdit(!showEdit)
  }
  /* Function call on cancel */
  const onCancel = () => {
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setEdit(!showEdit)
  }

  useEffect(() => {
    const updatedTooltipMetadata = tooltipMetadata.map(async (tooltip) => {

      let userDisplayName = ''
      if (tooltip.ItemModifiedBy) {
        const userProfile = await getUserProfile({ userRID: tooltip.ItemModifiedBy })
        userDisplayName = userProfile[0]?.UserDisplayName || ''
      }  
        return {
          ItemKey: tooltip.eKey,
          created: tooltip.ItemCreated,
          description: tooltip.TooltipDescription,
          eTag: tooltip.eTag,
          labelid: tooltip.TooltipID,
          modifiedBy: userDisplayName,
          modifiedDate: convertDate(tooltip.ItemModified, 'date') ?? '', 
          name: tooltip.TooltipName,
        }
      })
    Promise.all(updatedTooltipMetadata).then((resolvedMetadata) => {
    resolvedMetadata.sort((a, b) => {
      if (!a.modifiedDate) return 1
      if (!b.modifiedDate) return -1
      return new Date(b.modifiedDate).getTime() - new Date(a.modifiedDate).getTime()
    })
    setTooltipItems(resolvedMetadata)
  })
      
    }, [tooltipMetadata, getUserProfile])
    
  return (
    <div className='row m-0'>
      <SettingsHeader name='Form Tooltips' />
      <div className='p-0 settings-main mt-2'>
        {tooltipItems.map((toolTip) => (
          <div
            className={
              showEdit
                ? 'd-flex flex-column shadow card poppins-medium mb-2 py-3 pb-0 active bgcolor-56 bordered16'
                : 'd-flex flex-column shadow card poppins-medium mb-2 py-3 my-2 mx-2'
            }
            key={toolTip.ItemKey}
          >
            {/* <div className="d-flex flex-column shadow card poppins-medium mb-2 py-3"> */}
            <div className='d-flex px-2'>
              <div className='d-flex flex-column flex-md-row flex-wrap w-100'>
                <div aria-live='polite' className='d-flex flex-column col my-2' tabIndex={0}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Tooltip Name
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {toolTip.name}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-250 w-100 max-w-250 my-2' tabIndex={0}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Tooltip ID
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {toolTip.labelid}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-250 w-100 max-w-250 my-2' tabIndex={0}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Description
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {toolTip.description}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div aria-live='polite' className='d-flex flex-column min-w-250 w-100 max-w-250 my-2' tabIndex={0}>
                  <div className='title-color35 poppins-semibold font-12'>
                    Modified
                  </div>
                  <div className='poppins-semibold font-12 title-color2'>
                   {toolTip.modifiedBy} | {toolTip.modifiedDate}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
              </div>
              <div className='d-flex align-items-center'>
                <div className='d-flex gap-1 settings-actionbtns mx-2 mx-xxl-3'>
                  <Buttons
                    aria-label='Edit'
                    className={
                      inEditMode.status &&
                      inEditMode.rowKey === toolTip.ItemKey
                        ? 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto bgcolor-primary whitetext text-nowrap sourcesansprosemibold active'
                        : 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                    }
                    icon='icon-pencil me-xl-1 font-10'
                    label='Edit'
                    onClick={() => onEdit(toolTip)}
                  />
                </div>
              </div>
            </div>
            {inEditMode.status && inEditMode.rowKey === toolTip.ItemKey ? (
              <AddEditView
               cancel={() => onCancel()} 
               editItems={toolTip}
               fetchMetdata={fetchTooltipMetdata}
               filtersvalue={addEditValue}
               showAddPopup={showAddPopup}
               />
            ) : (
              ''
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
export default FormTooltip
